import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wrapper wrapper--system" }
const _hoisted_2 = {
  key: 0,
  class: "messages"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MessageItem = _resolveComponent("MessageItem")

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messagesGroupedBySystemMessage, (messagesCollapsed) => {
      return (_openBlock(), _createElementBlock("div", {
        key: messagesCollapsed.id,
        class: "messages-group__system"
      }, [
        (messagesCollapsed.messages?.length > 1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _createVNode(_component_MessageItem, {
                "is-combined-system-message": "",
                "is-combined-system-message-collapsed": messagesCollapsed.collapsed,
                "next-message-id": $options.getNextMessageId(messagesCollapsed.messages.at(-1)),
                "previous-message-id": $options.getPrevMessageId(messagesCollapsed.messages.at(0)),
                "last-collapsed-message-id": messagesCollapsed.lastId,
                message: $setup.createCombinedSystemMessage(messagesCollapsed),
                onToggleCombinedSystemMessage: $event => ($options.toggleCollapsed(messagesCollapsed))
              }, null, 8, ["is-combined-system-message-collapsed", "next-message-id", "previous-message-id", "last-collapsed-message-id", "message", "onToggleCombinedSystemMessage"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("ul", {
          class: _normalizeClass(["messages", { 'messages--collapsed': messagesCollapsed.messages?.length > 1 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messagesCollapsed.messages, (message) => {
            return (_openBlock(), _createBlock(_component_MessageItem, {
              key: message.id,
              message: message,
              "is-collapsed-system-message": messagesCollapsed.messages?.length > 1,
              "last-collapsed-message-id": messagesCollapsed.lastId,
              "next-message-id": $options.getNextMessageId(message),
              "previous-message-id": $options.getPrevMessageId(message)
            }, null, 8, ["message", "is-collapsed-system-message", "last-collapsed-message-id", "next-message-id", "previous-message-id"]))
          }), 128))
        ], 2), [
          [_vShow, messagesCollapsed.messages?.length === 1 || !messagesCollapsed.collapsed]
        ])
      ]))
    }), 128))
  ]))
}